import { createLogger } from 'logger-js'
import { loadCategoriesAction } from 'modules/categories/actions'
import { loadHomeSSRAction } from 'modules/home/actions'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import shouldLoadCategoriesRouteUtil from 'modules/routes/utils/should-load-categories'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import loadRecommendedPlansAction from 'modules/plan/redux/actions/load-recommended'
import { loadBySharedKeyWorkoutAction } from 'modules/workout/redux/actions/load-by-share-key'
import loadRecommendedWorkoutsAction from 'modules/workout/redux/actions/load-recommended'
import loadSearchAction from 'modules/search/actions/load'
import loadSectionAction from 'modules/section/actions/load'
import { logUtil } from 'packages/src'
import loadByIdRouteExerciseAction from 'modules/exercise/redux/actions/load-by-id-route/index.js'
import loadInstanceSectionAction from 'modules/section/actions/index.js'
import loadByRecommendedIdPlanAction from 'modules/plan/redux/actions/load-recommended-by-id/index.js'
import { performLoadByIdWorkoutAction } from 'modules/workout/redux/actions/perfom-load-by-id/index.js'
import { performLoadPlanWorkoutByIdAction } from 'modules/workout/redux/actions/perform-load-plan-workout-by-id/index.js'

const ROUTE_PATH_TO_LOAD_FUNC = {
  [ROUTE_PATH.VIEW_EXERCISE_SLUG]: loadByIdRouteExerciseAction,
  [ROUTE_PATH.VIEW_EXERCISE]: loadByIdRouteExerciseAction,
  [ROUTE_PATH.ADD_EXERCISE]: loadByIdRouteExerciseAction,
  [ROUTE_PATH.CHECK_EXERCISE_FORM_SLUG]: loadByIdRouteExerciseAction,

  [ROUTE_PATH.PLANS_BY_TAG]: loadRecommendedPlansAction,
  [ROUTE_PATH.PLAN_BY_ID]: loadByRecommendedIdPlanAction,
  [ROUTE_PATH.PLAN_BY_ID_SLUG]: loadByRecommendedIdPlanAction,
  [ROUTE_PATH.PLAN_WORKOUT_BY_ID_SLUG]: performLoadPlanWorkoutByIdAction,
  [ROUTE_PATH.PLANS]: loadRecommendedPlansAction,

  [ROUTE_PATH.WORKOUTS]: loadRecommendedWorkoutsAction,
  [ROUTE_PATH.WORKOUTS_BY_TAG]: loadRecommendedWorkoutsAction,
  [ROUTE_PATH.WORKOUT_SHARED_BY_SHARE_KEY]: loadBySharedKeyWorkoutAction,
  [ROUTE_PATH.WORKOUT_BY_ID_SLUG]: performLoadByIdWorkoutAction,
  [ROUTE_PATH.WORKOUT_BY_ID]: performLoadByIdWorkoutAction
}

const loadCollectionRouteActionLogger = createLogger({
  label: 'loadCollectionRouteAction'
})

// /**
//  * Returns the promises necessary to load the route.
//  * @param  {Object} props
//  * @param  {Object} props.route
//  * @param  {Object} props.match
//  * @param  {Object} props.options
//  * @returns {Promise[]}
//  */
// function loadRouteAction ({
//   route,
//   match,
//   options
// }) {
//   return dispatch => {
//     return Promise.all(
//       dispatch(
//         getPromisesRouteAction({
//           route,
//           match,
//           options
//         })
//       )
//     )
//   }
// }

/**
 * Returns the promises necessary to load the route.
 * @param  {Object} props
 * @param  {Object} props.route
 * @param  {Object} props.match
 * @param  {Object} props.options
 * @param  {Object} props.ctx
 * @returns {Promise[]}
 */
function getPromisesRouteAction ({
  route,
  match,
  options,
  ctx
}) {
  return dispatch => {
    const promises = []
    const loaderFunction = ROUTE_PATH_TO_LOAD_FUNC[route.path]
    if (loaderFunction) {
      promises.push(
        dispatch(
          loaderFunction({
            route,
            match,
            options
          })
        )
      )
    }

    // If the route is an instance load it
    if (
      route.isInstance &&
      !loaderFunction
    ) {
      promises.push(
        dispatch(
          loadInstanceSectionAction({
            route,
            match,
            options,
            ctx
          })
        )
      )
    }

    // If the route is a collection load it
    if (
      route.isCollection &&
      !loaderFunction
    ) {
      promises.push(
        dispatch(
          loadCollectionRouteAction({
            route,
            match,
            options
          })
        )
      )
    }

    // If the route is an instance or collection, load the categories
    if (shouldLoadCategoriesRouteUtil(route, match)) {
      promises.push(
        dispatch(
          loadCategoriesAction({
            route,
            match,
            options
          })
        )
      )
    }
    return promises
  }
}

/**
 * Gets the function to call to load the collection.
 * @private
 * @param  {Object} route
 * @returns {Function}
 */
function getLoadCollection ({ route }) {
  logUtil('getLoadCollection').debug('[start] route=', route)
  if (!route) {
    logUtil('getLoadCollection').debug('[noop] no route')
    return
  }

  const { section } = route
  if (section === SECTIONS_NAME.HOME) {
    return loadHomeSSRAction
  }
  if (section === SECTIONS_NAME.SEARCH) {
    return loadSearchAction
  }
  return loadSectionAction
}

/**
 * @param props
 * @param props.route
 * @param props.match
 * @param props.options
 */
function loadCollectionRouteAction ({
  route,
  match,
  options
}) {
  return dispatch => {
    const funcAction = getLoadCollection({ route })
    if (!funcAction) {
      loadCollectionRouteActionLogger.debug('[not_found] route: ', route)
      return
    }
    loadCollectionRouteActionLogger.debug('[start]')
    return dispatch(
      funcAction(route, match, options)
    )
  }
}

export {
  getPromisesRouteAction,
  loadCollectionRouteAction
}
